/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedItems } from '../models/PagedItems';
import type { PagingQuery } from '../models/PagingQuery';
import type { TerminalConfigCreate } from '../models/TerminalConfigCreate';
import type { TerminalConfigDetails } from '../models/TerminalConfigDetails';
import type { TerminalConfigUpdate } from '../models/TerminalConfigUpdate';
import { request as __request } from '../core/request';

export class TerminalConfigsVService {

    /**
     * @param operatorId
     * @param requestBody
     * @returns PagedItems OK
     * @throws ApiError
     */
    public static async terminalConfigsVGetAll(
        operatorId: string,
        requestBody?: PagingQuery,
    ): Promise<PagedItems> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/Operators/${operatorId}/terminal-configs/get`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param operatorId
     * @param requestBody
     * @returns TerminalConfigDetails OK
     * @throws ApiError
     */
    public static async terminalConfigsVGetExport(
        operatorId: string,
        requestBody?: PagingQuery,
    ): Promise<TerminalConfigDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/Operators/${operatorId}/terminal-configs/export`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param operatorId
     * @param terminalConfigId
     * @param requestBody
     * @returns TerminalConfigDetails OK
     * @throws ApiError
     */
    public static async terminalConfigsVUpdateTerminalConfig(
        operatorId: string,
        terminalConfigId: string,
        requestBody?: TerminalConfigUpdate,
    ): Promise<TerminalConfigDetails> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/v2/Operators/${operatorId}/terminal-configs/${terminalConfigId}`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param operatorId
     * @param terminalConfigId
     * @returns TerminalConfigDetails OK
     * @throws ApiError
     */
    public static async terminalConfigsVGetById(
        operatorId: string,
        terminalConfigId: string,
    ): Promise<TerminalConfigDetails> {
        const result = await __request({
            method: 'GET',
            path: `/api/v2/Operators/${operatorId}/terminal-configs/${terminalConfigId}`,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
        return result.body;
    }

    /**
     * @param operatorId
     * @param terminalConfigId
     * @returns any No Content
     * @throws ApiError
     */
    public static async terminalConfigsVDelete(
        operatorId: string,
        terminalConfigId: string,
    ): Promise<any> {
        const result = await __request({
            method: 'DELETE',
            path: `/api/v2/Operators/${operatorId}/terminal-configs/${terminalConfigId}`,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
        return result.body;
    }

    /**
     * @param operatorId
     * @param requestBody
     * @returns TerminalConfigDetails Created
     * @throws ApiError
     */
    public static async terminalConfigsVCreate(
        operatorId: string,
        requestBody?: TerminalConfigCreate,
    ): Promise<TerminalConfigDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/Operators/${operatorId}/terminal-configs`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
        return result.body;
    }

}